<template>
  <v-dialog
    :model-value="dialog"
    @update:value="updateDialog"
    max-width="320"
    persistent
  >
    <v-card>
      <v-card-title class="text-h5 pt-4 pl-6"
        >Are you still there?</v-card-title
      >

      <v-card-text class="py-2" style="color: black">
        <v-row>
          <v-col>
            {{ stayLoggedInText }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="py-4">
            <span>Stay logged in?</span>
          </v-col>
          <v-col><v-spacer></v-spacer></v-col>
          <v-col cols="3" class="py-0" justify="end">
            <v-switch
              v-model="stayLoggedIn"
              class="mt-0 pt-0 switch-end"
              color="primary"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mb-2" large @click="reauthButtonPressed">
          I'm still here
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { useEventBus } from "@/event-bus/bus";
import $const from "@/utils/constants";

export default {
  data() {
    return {
      localSeconds: 30,
      countdownInterval: null,
      stayLoggedIn: false,
    };
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    seconds: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    dialog: {
      handler() {
        console.log(`stayloggedin dialog: ${this.dialog}`);
        if (this.dialog) {
          this.startCountDown();
          this.stayLoggedIn = this.sessionAutoRefresh;
        }
      },
      immediate: true,
    },
    seconds() {
      console.log(`dialog seconds changed... ${this.seconds}`);
      this.localSeconds = this.seconds;
    },
  },
  computed: {
    ...mapGetters("auth", ["sessionAutoRefresh"]),
    stayLoggedInText() {
      return `Your session is about to expire in ${this.localSeconds} seconds. Would you like to stay logged in?`;
    },
  },
  methods: {
    updateDialog(value) {
      this.$emit("update:dialog", value);
    },
    startCountDown() {
      console.log("startCountDown");
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }

      this.countdownInterval = setInterval(() => {
        if (this.localSeconds - 1 < 0) {
          console.log("logout user");
          this.$emit("logout");
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
        } else {
          this.localSeconds -= 1;
        }
      }, 1000);
    },
    reauthButtonPressed() {
      console.log("reauthButtonPressed...");
      this.$emit("reauth", this.stayLoggedIn);
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    },
    logOutUser() {
      this.$store
        .dispatch("auth/logout")
        .then(() => {
          console.log("unloading me...");
          return this.$store.dispatch("user/unloadMe");
        })
        .then(() => {
          console.log("clearing impersonation...");
          return this.$store.dispatch("auth/clearImpersonate");
        })
        .then(() => {
          console.log("redirecting...");
          this.$router.push({ name: "login" });
        });
    },
  },
  mounted() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  },
  beforeUnmount() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }

    const _eventBus = useEventBus();
    _eventBus.$off($const.EVENT_BUS.UPDATE_PASSWORD, this.showPasswordUpdate);
  },
};
</script>

<style scoped>
.switch-end >>> .v-input__slot {
  justify-content: flex-end;
}
</style>
